<script lang="ts" module>
  import type { VariantProps } from 'tailwind-variants';

  import { Icon } from '@/ui/base';
  import { tv } from '@/ui/tv';

  const styles = tv({
    slots: {
      root: 'fc-cc relative w-3 self-stretch',
      line: 'absolute left-[5px] -z-0 w-0.5  bg-info',
      icon: 'z-10',
    },
    variants: {
      pos: {
        first: {
          line: 'top-1/2 h-1/2',
        },
        last: {
          line: 'bottom-1/2 h-1/2',
        },
        default: {
          line: 'h-full',
        },
      },
      selected: {
        true: {
          icon: 'text-c-bullet-S',
        },
        false: {
          icon: 'text-c-bullet',
        },
      },
    },
  });

  export interface VersionBulletProps extends VariantProps<typeof styles> {
    class?: string;
  }
</script>

<script lang="ts">
  let props: VersionBulletProps = $props();
  let cn = $derived(styles(props));
</script>

<div class={cn.root()}>
  <div class={cn.line()}>
    <div class="size-full bg-prim-H"></div>
  </div>
  <Icon icon="Bullet" size={props.selected ? 3 : 2} class={cn.icon()} />
</div>
